// eslint-disable-next-line @typescript-eslint/no-explicit-any -- We don't know the type of the event
export type Callback<T = any> = (arg: T) => void | Promise<void>;

export class EventEmitter<TEvent extends string = string> {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- We don't know the type of the event
	private listeners: Record<string, Set<Callback<any>>> = {};

	public on<T>(eventName: TEvent, cb: Callback<T>): void {
		if (!(eventName in this.listeners)) {
			this.listeners[eventName] = new Set<Callback<T>>();
		}

		this.listeners[eventName]?.add(cb);
	}

	public off<T>(eventName: TEvent, cb: Callback<T>): void {
		if (eventName in this.listeners) {
			this.listeners[eventName]?.delete(cb);
		}
	}

	public emit<T>(eventName: TEvent, arg: T): void {
		const listeners = this.listeners[eventName];

		if (!listeners) {
			return;
		}

		listeners.forEach((listener) => {
			listener(arg);
		});
	}

	public clear(): void {
		this.listeners = {};
	}
}
